export default __webpack_public_path__ + "static/media/lomoIcon4Complete.4e2aee58.svg";